import storage from './storage';

export const REMINDER_WEB_NOTIF_KEY = 'crm_reminder_web_notif';

export function isReminderWebNotifEnabled() {
  return !!storage.get(REMINDER_WEB_NOTIF_KEY, false);
}

export function setReminderWebNotifEnabled(value) {
  storage.set(REMINDER_WEB_NOTIF_KEY, !!value);
}

export function getNotificationPermission() {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission;
}

export async function requestReminderNotificationPermission() {
  if (typeof Notification === 'undefined') return 'unsupported';
  try {
    return await Notification.requestPermission();
  } catch {
    return 'denied';
  }
}

/**
 * Einmal pro Tag / pro Eintrag (sessionStorage), wenn fällig.
 */
export function runReminderNotificationTick({ tasks = [], leads = [] } = {}) {
  if (!isReminderWebNotifEnabled()) return;
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;

  const day = new Date().toISOString().slice(0, 10);
  const now = Date.now();

  const wasSent = (key) => {
    try {
      return sessionStorage.getItem(key) === '1';
    } catch {
      return false;
    }
  };
  const markSent = (key) => {
    try {
      sessionStorage.setItem(key, '1');
    } catch { /* ignore */ }
  };

  tasks.forEach((t) => {
    if (t.done || t.dismissed || !t.dueDatetime) return;
    if (new Date(t.dueDatetime).getTime() > now) return;
    const key = `crm_webnotif_task_${t.id}_${day}`;
    if (wasSent(key)) return;
    markSent(key);
    try {
      new Notification('Aufgabe fällig', {
        body: t.title || 'Ohne Titel',
        tag: `crm-task-${t.id}`,
      });
    } catch {
      /* ältere Browser / iOS */
    }
  });

  leads.forEach((l) => {
    if (!l.wiedervorlage) return;
    const w = String(l.wiedervorlage).slice(0, 10);
    if (w !== day) return;
    const key = `crm_webnotif_wv_${l.id}_${day}`;
    if (wasSent(key)) return;
    markSent(key);
    try {
      const body = `${l.name || 'Lead'}${l.company ? ` · ${l.company}` : ''}`.trim();
      new Notification('Wiedervorlage heute', { body, tag: `crm-wv-${l.id}` });
    } catch {
      /* ignore */
    }
  });
}
